// @flow
import styled from 'styled-components';
import { createMedia } from '../..';
var media = createMedia();
/*::
  import type { Node } from 'react';

  export type StatisticsTheme = {|
    Main: * => Node,
    Title: * => Node,
    Description: * => Node,
  |};
*/

var Theme
/*: StatisticsTheme */
= {
  Main: styled.div.withConfig({
    displayName: "theme__Main",
    componentId: "sc-15tkvex-0"
  })(["box-sizing:border-box;position:relative;padding-left:0.8rem;border-left:4px solid ", ";"], function (pr) {
    return pr.color;
  }),
  Title: styled.p.withConfig({
    displayName: "theme__Title",
    componentId: "sc-15tkvex-1"
  })(["box-sizing:border-box;display:block;font-size:1.5rem;font-weight:400;text-transform:uppercase;margin:0;", "{font-size:1.8rem;}"], media.sm),
  Description: styled.div.withConfig({
    displayName: "theme__Description",
    componentId: "sc-15tkvex-2"
  })(["padding-left:0.5rem;h3{margin:0;font-size:4.5rem;font-weight:200;line-height:6.3rem;", "{font-size:4.2rem;}}"], media.sm)
};
export default Theme;